import ControlPanel from "./PointCloudToolbar";

export default ControlPanel;